var CustomEvent = require('../constants/customEvent')

module.exports = Em.Component.extend({
    layoutName: 'components/customer-edit-modal',

    customEvent: Em.inject.service(),

    userOrganizations: Em.inject.service(),

    organization: Em.computed.oneWay('userOrganizations.activeOrganization'),

    contactId: null,

    isOpen: false,

    callback: null,

    customActions: {
        customerUpdated: function() {
            this.get('customEvent').dispatchEvent(CustomEvent.ContactUpdated)

            if (typeof this.get('callback') === 'function') {
                this.get('callback')()
            }
        },

        closeEmber: function() {
            this.set('isOpen', false)
        }
    }
})
